import React, {Component} from 'react';
import './Contact.css';
import Linkedin1 from './assets/Linkedin01.png';
import Facebook1 from './assets/facebook01.png';
import Github1 from './assets/GitHub01.png';


class Contact extends Component {
    state = {  }
    render() { 
        return ( 
                <div className="divEducationStyle">
                <div className="divAboutMeHeader" >
                   <h1 >  Contact </h1>
                   <hr className="solid-Contacts"></hr>
                </div>
                <div className="divContactDetails">
                    <p>
                    Have a backend, cloud, automation, or AI-enabled systems idea? Send a note and I will get back to you.
                    </p>
                </div>
                <div className="divContact-wrapper">
                    <div className="divContact-info">
                        <h3>Let's connect</h3>
                        <p>
                        I am open to conversations around backend engineering, cloud-native systems, warehouse automation, event-driven architecture, and AI-assisted workflows.
                        </p>
                        <div className="divContact-email">
                            <h4 className= "h3-Contact-media">
                                Email
                            </h4>
                            <a href="mailto:ankitlalwani30@gmail.com">ankitlalwani30@gmail.com</a>
                        </div>
                        <div className="divContact-media">
                            <h4 className= "h3-Contact-media">Social media</h4>
                            
                            <a className="divOtherHREF" href="https://www.linkedin.com/in/ankit-lalwani/" target = "_blank" rel="noopener noreferrer" aria-label="LinkedIn profile">
                                <img className="divOtherImage" src={Linkedin1} alt="LinkedIn"></img></a>
                            <a className="divOtherHREF" href="https://www.facebook.com/ankit.lalwani.58" target = "_blank" rel="noopener noreferrer" aria-label="Facebook profile">
                                <img className="divOtherImage" src={Facebook1} alt="Facebook"></img></a>
                            <a className="divOtherHREF" href="https://github.com/ankitlalwani" target = "_blank" rel="noopener noreferrer" aria-label="GitHub profile">
                                <img className="divOtherImage" src={Github1} alt="GitHub"></img></a>
                        </div>
                    </div>
                    <form className="contactForm" action="https://formspree.io/f/maqzkgzw" method="POST">
                        <div className="contactForm-row">
                            <label>
                                Name
                                <input type="text" name="name" placeholder="Your name" required />
                            </label>
                            <label>
                                Email
                                <input type="email" name="email" placeholder="your.email@example.com" required />
                            </label>
                        </div>
                        <label>
                            Subject
                            <input type="text" name="subject" placeholder="What would you like to discuss?" required />
                        </label>
                        <label>
                            Message
                            <textarea name="message" rows="6" placeholder="Tell me a little about your project, opportunity, or question." required></textarea>
                        </label>
                        <input type="hidden" name="_subject" value="New portfolio contact form message" />
                        <button type="submit">Send Message</button>
                    </form>
                </div>
                </div>
         );
    }
}
 
export default Contact;
